const list = {
  components() {
    return [
      {
        component: 'search-year',
        label: '연도',
        value: 'year',
        query: { y: 'year' },
        options: { default: new Date().getFullYear() },
      },
      {
        component: 'search-check-group',
        label: '정기점검',
        value: 'regular',
        query: { ck_re: 'checkList' },
        options: {
          list: [
            { text: '상반기', value: '상반기' },
            { text: '하반기', value: '하반기' },
          ],
          default: [],
        },
      },
      {
        component: 'search-check-group',
        label: '수시점검',
        value: 'adHoc',
        query: { ck_ad: 'checkList' },
        options: {
          list: [
            { text: '해빙기', value: '해빙기' },
            { text: '우수기', value: '우수기' },
            { text: '동절기', value: '동절기' },
            { text: '기타', value: '기타' },
          ],
          default: [],
        },
      },
      { component: 'empty-space' },
      {
        component: 'search-start-end',
        label: '작성일',
        value: 'date',
        query: { ss: 'startDate', ee: 'endDate' },
        options: { default: { sd: '', ed: '' } },
      },
      {
        component: 'search-column-keyword',
        label: '검색조건',
        value: 'column',
        query: { ck_t: 'head', ck_k: 'keyword' },
        options: { hiddenList: ['재해형태', '구분', '작성일'] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    if (search.year) {
      conditions.push({ key: 'body.점검연도', operator: '=', value: `${search.year}` });
    }
    if (search.regular && search.regular.length > 0) {
      conditions.push({ key: 'body.정기점검', operator: 'IN', value: search.regular });
    }
    if (search.adHoc && search.adHoc.length > 0) {
      conditions.push({ key: 'body.수시점검', operator: 'IN', value: search.adHoc });
    }

    if (search.date) {
      conditions.push({ key: 'created_at', operator: '>=', value: search.date.startDate });
      conditions.push({ key: 'created_at', operator: '<', value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format('yyyy-MM-dd') : '' });
    }

    const heads = list.getHead().map((e) => { return { [e.name]: e.key }; });
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%` });
    }

    return conditions;
  },

  getHead: () => {
    return [
      { name: '연도', key: 'body.점검연도' },
      { name: '구분', key: 'body.점검구분' },
      { name: '시설물명', key: 'body.fields[%].field_name', style: { maxWidth: '260px', whiteSpace: 'normal', wordBreak: 'break-all' } },
      { name: '팀명', key: 'body.stdInfo.section' },
      { name: '작성자', key: 'body.stdInfo.writer_name' },
      { name: '작성일', key: 'created_at' },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).점검연도 || '';
        case 1: {
          const content = func.getContent(value);
          const items = [];
          if (content.정기점검) items.push(`정기점검(${content.정기점검})`);
          if (content.수시점검) items.push(`수시점검(${content.수시점검})`);
          return items.join(', ') || '';
        }
        case 2: {
          const content = func.getContent(value);
          if (content.fields && content.fields.length > 0) return content.fields.map((e) => e.field_name).join(', ');
          return '';
        }
        case 3: return func.getContent(value).stdInfo.section;
        case 4: return func.getContent(value).stdInfo.writer_name;
        case 5: return func.getCreatedDate(value.created_at);
      }
    } catch (e) { /*ignore*/ }
    return '';
  },

  getSearchKeyValue: () => {},
  getSearchKeyword: () => {},
};

export default list;
